import { render, staticRenderFns } from "./policyInformation.vue?vue&type=template&id=448ea582&scoped=true"
import script from "./policyInformation.vue?vue&type=script&lang=js"
export * from "./policyInformation.vue?vue&type=script&lang=js"
import style0 from "./policyInformation.vue?vue&type=style&index=0&id=448ea582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ea582",
  null
  
)

export default component.exports